import { ResponseStatus } from '@revenuemarket/http';
import { overlays } from '@revenuemarket/overlays';
import { useFullSpinnerStore } from '@revenuemarket/react';
import { Toast } from '@revenuemarket/ui';
import { getCookie } from 'cookies-next';

import { API } from '~apis/axios/instance';
import { getASTDownloadUrl } from '~apis/wiring';
import ASTDownloadModal from '~components/AST/ASTDownloadModal';
import { API_URL } from '~constants/env';

import { useCompanyId } from './useCompanyId';

const useASTManage = async () => {
  const { companyId } = useCompanyId();
  const { showFullSpinner, hideFullSpinner } = useFullSpinnerStore();

  const getPCLOGData = async () => {
    const astx2 = await import('../public/ast/astx2.min.js');
    return new Promise((resolve) => {
      astx2.$ASTX2.getPCLOGData(
        null,
        async function onSuccess(data: any) {
          const url = API_URL + `/api/v2/companies/${companyId}/ast/pclog`;
          const cookie = getCookie('access_super_token') || getCookie('accessToken');
          await API.post(url, {
            data: {
              pclog_data: data.pclog_data,
            },
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              Authorization: `Bearer ${cookie}`, // Adjust with your actual token
            },
          })
            .then((response) => {
              resolve(true);
            })
            .catch((error) => {
              Toast.error('Ahnlab safe transaction PC Log data 인식에 실패했습니다.');
              resolve(false);
            });
        },
        function onError() {
          Toast.error('Ahnlab safe transaction PC Log data 인식에 실패했습니다.');
          resolve(false);
        },
      );
    });
  };

  const checkServer = async () => {
    const astx2 = await import('../public/ast/astx2.min.js');
    return new Promise((resolve) => {
      astx2.$ASTX2.checkServer(
        async function onSuccess() {
          const result = await getPCLOGData();
          resolve(result);
        },
        function onError() {
          const errno = astx2.$ASTX2.getLastError();
        },
      );
    });
  };

  const onGetDownloadUrl = async () => {
    const url = await getASTDownloadUrl({
      companyId,
      osType: window.navigator.platform.includes('Mac') ? 'MAC' : 'WINDOWS',
    });

    if (url.Status === ResponseStatus.SUCCESS) {
      // url로 다운로드
      window.open(url.Data?.data?.url, '_blank');
    } else {
      Toast.error('AST 다운로드 URL을 가져오는데 실패했습니다.');
    }
  };

  const load = async () => {
    const astx2 = await import('../public/ast/astx2.min.js');
    return new Promise((resolve) => {
      astx2.$ASTX2_CUST.setCustomerID(companyId);
      astx2.$ASTX2.init(
        async function onSuccess() {
          const result = await checkServer();
          resolve(result);
        },
        function onError() {
          const errno = astx2.$ASTX2.getLastError();
          if (errno == astx2.$ASTX2_CONST.ERROR_NOTINST) {
            hideFullSpinner();
            overlays.open(({ isOpen, onClose }) => (
              <ASTDownloadModal open={isOpen} onCancel={onClose} onOk={onGetDownloadUrl} />
            ));
            resolve(false);
          } else {
            Toast.error('Ahnlab safe transaction 설치 여부 확인에 실패했습니다.');
            resolve(false);
          }
        },
      );
    });
  };

  const check = async () => {
    const response = await load();
    return response;
  };

  return {
    check,
  };
};

export default useASTManage;
